/* newtestdesign · the sheet builder page (sections/ntd-builder.liquid).
   The builder is the live one, unchanged (sticker-sheet-builder.js). After "Add to cart" it hands the
   cart's answer to the page's <cart-drawer> when there is one — getSectionsToRender() for the sections
   to send back, renderContents() to show them — and otherwise opens the cart page. This gives it one
   that is the new cart drawer (NTD.openCart in ntd.js): the shopper stays on the builder and sees the
   sheet in the cart. Setting "After Add to cart: go to the cart page" = no stand-in, as now.
   It also marks the header's cart, so nd-builder.js flies the sheet into it as on the current site. */
(function () {
  "use strict";
  var doc = document, kit = doc.querySelector("[data-ntd-builder]");
  var cartBtn = doc.querySelector(".ntd-cart-btn");
  if (cartBtn && !doc.querySelector("[data-cart-icon]")) cartBtn.setAttribute("data-cart-icon", "");
  if (!kit || kit.getAttribute("data-after-add") !== "drawer" || doc.querySelector("cart-drawer")) return;
  var drawer = doc.createElement("cart-drawer");
  drawer.hidden = true;
  // a section Shopify can draw for the answer (the drawer's own, small); the drawer itself redraws from /cart.js
  drawer.getSectionsToRender = function () { return [{ id: "ntd-cart-drawer" }]; };
  drawer.renderContents = function (item) {
    var N = window.NTD;
    if (N && N.openCart) N.openCart(item && item.key, true);
    else location.href = (N && N.routes && N.routes.cart) || "/cart";
  };
  doc.body.appendChild(drawer);
})();
